import { Result } from "antd";
import { FunctionComponent } from "react";

interface ExtensionInstalledProps {}

const ExtensionInstalled: FunctionComponent<ExtensionInstalledProps> = () => {
  return (
    <Result
      status="success"
      title="Gear extension installed"
      subTitle="Please! Restart the browser to apply the changes."
    />
  );
};

export default ExtensionInstalled;
